var _defs, _title, _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSmartViewMDcom = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#09f;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:55px;}.cls-3{fill:#fff;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "svmd_logo")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1024,
    height: 1024,
    rx: 225.02
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "252.05 386.18 195.27 386.18 195.27 637.42 386.56 637.42 386.56 828.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "795.17 638.93 828.73 638.93 828.73 386.18 638.02 386.18 638.02 195.58"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 516.14,
    cy: 265.5,
    r: 21.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 431.4,
    cy: 274.64,
    r: 25.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 356.62,
    cy: 314.36,
    r: 31.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 336.34,
    cy: 403.19,
    r: 38.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 409.79,
    cy: 466.69,
    r: 42.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 505.23,
    cy: 508.1,
    r: 47.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 697.41,
    cy: 620.52,
    r: 53.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 610.4,
    cy: 549.29,
    r: 48.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 639.55,
    cy: 729.39,
    r: 58.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 512.48,
    cy: 757.77,
    r: 64.66
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmartViewMDcom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SmartViewMD.com.69ef083d.svg";
export { ForwardRef as ReactComponent };